import Crud from '../views/Central/Crud'
import Entity from '../views/Central/Add'

let routes = {
    path: '/centrais',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/centrais/add',
            name: 'NewCentral',
            component: Entity
        },
        {
            path: '/centrais/edit/:id?',
            name: 'EditCentral',
            component: Entity
        },
        {
            path: '/centrais',
            name: 'list-centrais',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Centrais',
                breadcrumb: [
                    {
                        text: 'Centrais',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
